import { ColumnType } from "../../types/dataGridTypes";

const useExploratoryColumns = () => {
  const values: any = [{ value: "In Progress", label: "In Progress" }];
  const exploratoryListColumns: ColumnType[] = [
    {
      field: "exploratory_id",
      headerName: "Exploratory Analysis ID",
      minWidth: 140,
      flex: 1,
      cmp: "link",
      linkPermission: "VIEW_STUDY_DETAILS",
      badge: true,
    },
    {
      field: "created",
      headerName: "Created",
      width: 100,
    },
    {
      field: "studyID",
      headerName: "Study ID",
      minWidth: 160,
      flex: 1,
      cmp: "link",
      linkPermission: "VIEW_STUDY_DETAILS",
    },
    {
      field: "testName",
      headerName: "Test Name",
      minWidth: 240,
      flex: 1,
      linkPermission: "VIEW_STUDY_DETAILS",
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.75,
      minWidth: 100,
      type: "singleSelect",
      valueOptions: values,
      cmp: "chip",
    },
    {
      field: "lastupdate",
      headerName: "Last Updated",
      width: 140,
    },
    {
      field: "actionsColumn",
      width: 90,
      type: "actions",
      cmp: "actions",
      headerName: "Action",
      sortable: false,
      filterable: false,
      actionsArray: [
        { icon: "Edit", label: "Edit", key: "action_edit" },
        { icon: "Delete", label: "Delete", key: "action_delete" },
      ],
    },
  ];
  return exploratoryListColumns;
};

export default useExploratoryColumns;
